import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

// Dummy metrics
const metrics = [
  { label: 'Storage Size', value: '12.4 TB', color: '#00b4a0' },
  { label: 'No. of Events', value: '8,234,120', color: '#1e90ff' },
  { label: 'Total Topics', value: 42, color: '#ab47bc' },
  { label: 'Total Consumption', value: '6.2 TB', color: '#ffa726' },
];

const Path3ArcSight = () => {
  return (
    <>
        <Grid item xs={12} md={5}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: '#60a5fa' }}>
            Legacy Path Metrics ArcSight
          </Typography>
          <Grid container spacing={1.5} sx={{ mb: 1.5, border: '1px solid rgba(255,255,255,0.1)', borderRadius: 2, p: 2 }}>
            {metrics.map((m, i) => (
              <Grid item xs={6} key={m.label}>
                <Card sx={{ background: 'rgba(10,34,64,0.85)', borderRadius: 3, boxShadow: 3, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <CardContent sx={{ textAlign: 'center', width: '100%', p: 1.5 }}>
                    <Typography variant="subtitle2" sx={{ color: m.color, fontWeight: 700 }}>{m.label}</Typography>
                    <Typography variant="h5" sx={{ fontWeight: 900, mt: 1, color: 'white' }}>{m.value}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: '#60a5fa' }}>
            Filtered Path Metrics ArcSight
          </Typography>
          <Grid container spacing={1.5} sx={{ mb: 1.5, border: '1px solid rgba(255,255,255,0.1)', borderRadius: 2, p: 2 }}>
            {metrics.map((m, i) => (
              <Grid item xs={6} key={m.label}>
                <Card sx={{ background: 'rgba(10,34,64,0.85)', borderRadius: 3, boxShadow: 3, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <CardContent sx={{ textAlign: 'center', width: '100%', p: 1.5 }}>
                    <Typography variant="subtitle2" sx={{ color: m.color, fontWeight: 700 }}>{m.label}</Typography>
                    <Typography variant="h5" sx={{ fontWeight: 900, mt: 1, color: 'white' }}>{m.value}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: '#60a5fa' }}>
            AI-Enriched Path Metrics ArcSight
          </Typography>
          <Grid container spacing={1.5} sx={{ mb: 1.5, border: '1px solid rgba(255,255,255,0.1)', borderRadius: 2, p: 2 }}>
            {metrics.map((m, i) => (
              <Grid item xs={6} key={m.label}>
                <Card sx={{ background: 'rgba(10,34,64,0.85)', borderRadius: 3, boxShadow: 3, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <CardContent sx={{ textAlign: 'center', width: '100%', p: 1.5 }}>
                    <Typography variant="subtitle2" sx={{ color: m.color, fontWeight: 700 }}>{m.label}</Typography>
                    <Typography variant="h5" sx={{ fontWeight: 900, mt: 1, color: 'white' }}>{m.value}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
    </>
  )
}

export default Path3ArcSight;